// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.benchmarks-left-nav ul {
    margin-top: 20%;
}

.benchmarks-left-nav li {
    padding: 11px 0px;
    padding-left: 40px;
    word-break: break-word;
    cursor: not-allowed;
    color: #ccc;
}

.benchmarks-left-nav a {
    cursor: not-allowed;
}

.benchmarks-left-nav li.active, .benchmarks-left-nav li.active a {
    cursor: pointer; 
    background-color: hsl(0, 0%, 90%) !important;
    color: #000;
}

.benchmarks-left-nav li.completed, .benchmarks-left-nav li.completed a {
    cursor: pointer; 
    color: #000;
}

.upload-task .uppy-comp {
    margin: 2% 15%;
}

.upload-task, .validation-task {
    padding: 3%;
}

.uppy-uploader-component {
    margin-top: 3%;
}

/* .uppy-uploader-component span{
    margin-left: 2rem;
} */

.upload-task .uppy-Dashboard {
    height: 23rem;
}

.next-upon-success button{
    float: right;
    cursor: pointer;
}
.next-upon-success button{
    margin-top: 5px;
}

.upload-task .uploaded-files {
    margin-left: 2rem;
    margin-top: 20px;
}

.upload-task .file-list-heading {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
  }
  
  .upload-task .file-list {
    list-style: none;
    padding: 0;
  }
  
  .upload-task .file-list-item {
    font-size: 16px;
    margin-bottom: 5px;
    text-decoration: none;
    transition: color 0.3s;
  }
  
  .upload-task .file-list-item:hover {
    color: #007bff; /* Change the color on hover */
  }
  


  /* ValidationTaskComponent.css */

.validation-task .container {
    padding: 20px;
    border-radius: 10px;
    background-color: #f5f5f5;
  }
  
  .validation-task .header {
    font-size: 24px;
    color: #333;
    margin-bottom: 20px;
  }
  
  .validation-task .spinner-container, .spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
  }
  
  .navigation-buttons .button, .next-upon-success button {
    margin: 10px;
    padding: 10px 20px;
    background-color: #007BFF;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .navigation-buttons .button:hover {
    background-color: #0056b3;
  }

.navigation-buttons {
    display: flex;
    margin-top: 2rem;
}

.navigation-buttons .previous, .navigation-buttons .next-upon-success {
    flex: 1 1;
}


.task-builder-task .task-section, .task-builder-task .task-id-section, .task-builder-task .metadata-section, .task-builder-task .metadata-item, .task-builder-task .split-parameters {
  margin-bottom: 15px;
}

.task-builder-task h3 {
  font-size: 18px;
  margin-bottom: 10px;
}

.task-builder-task label {
  display: block;
  margin-bottom: 2rem;
  font-weight: 500;
}

.task-builder-task label p{
  margin-bottom: 5px;
}

.task-builder-task input[type="range"] {
  width: 80%;
}

.task-builder-task button {
  margin: 10px;
  padding: 10px 20px;
  background-color: #007BFF;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.task-builder-task button:hover {
  background-color: #0056b3;
}



.review-task {
  width: 95%;
  margin: auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.section {
  margin-bottom: 20px;
}

.section-heading {
  background-color: rgb(248, 249, 250)  ;
  color: black;
  padding: 10px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  outline: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 2rem;
}

.section-heading i {
  font-size: 16px;
  margin-right: 8px;
}

.section-content {
  display: none;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 10px;
  margin-top: 10px;
}


/* FlowControl.css */
.flow-messaging {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: Arial, sans-serif;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: 5rem 25rem;
  padding: 4rem 2rem;
}

.flow-messaging h3 {
  text-align: center;
  margin-bottom: 20px;
  padding: 0 7rem;
}

.flow-messaging button {
  margin: 10px;
  padding: 10px 20px;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  background-color: #007BFF;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.flow-messaging button:hover {
  background-color: #0056b3;
}

.uppy-uploader-component .info-icon {
  top: 0px !important;
  float: left;
}

.upload-task .files-selected button.cross-button {
  cursor: pointer;
}

#files-selected ul {
  padding-left: 0px;
}

.task-builder-task .dialog-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 999;
}

.task-builder-task .dialog {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  width: 80%;
  max-height: 90vh;
  overflow-y: auto;
  background-color: #ffffff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 20px;
}


/* Additional styles for FilterComponent */
.task-builder-task .dialog-container .filter {
  flex: 1 1;
}

.task-builder-task .dialog-container .pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.task-builder-task .dialog-container .pagination button {
  padding: 5px 10px;
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  cursor: pointer;
}

.task-builder-task .dialog-container .pagination button:disabled {
  background-color: #e0e0e0;
  cursor: default;
}

.task-builder-task .dialog-container .pagination span {
  margin: 0 10px;
}

.task-builder-task .dialog-container .filters-and-search-container {
  display: flex;
}

.task-builder-task .dialog-container span.search-title {
  font-weight: 700;
  color: #666;
  display: block;
  margin: 3px 0;
}

.task-builder-task .dialog-container .facet {
    white-space: nowrap;
    display: inline-block;
    margin-right: 8px;
    box-sizing: border-box;
    vertical-align: top;
    cursor: pointer;
}

.task-builder-task .dialog-container .table-results {
  overflow-y: auto;
}

.task-builder-task .dialog-container .table-results table{

  width: 100%;
}

.task-builder-task .dialog-container .facet p {
  background-color: #fff;
  padding: 8px 16px;
  border-radius: 15px;
  border: 0.64px solid #4d72aa;
  width: 100%;
  box-sizing: border-box;
  display: inline-block;
}

.task-builder-task .dialog-container .facet .filters-box-searchable {
  width: 375px;
  border: 1px solid #aaa;
  background: #fff;
  position: absolute;
  z-index: 9000;
  border-radius: 5px;
  padding: 1rem;
  margin-top: 2px;
}

.task-builder-task .dialog-container .facet .filters-box-searchable {
  display: flex;
  flex-direction: column;
}


.task-builder-task .dialog-container .facet .filters-box-footer {
  height: 40px;
}

.task-builder-task .dialog-container button.filters-toggle{
  margin-top: 18px;
  white-space: nowrap;
    margin-right: 8px;
    vertical-align: top;

    background-color: #fff;
    color: black;
    border-radius: 15px;
    border: 0.64px solid #4d72aa;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    display: flex;
    padding: 0px 16px;
    height: 40px;
}

.task-builder-task .dialog-container .filters-toggle-div {
  display: inline-block;
}

.task-builder-task .dialog-container .metadata-search-wrap {
  flex: 0 0 60%;
}

.task-builder-task .dialog-container .study-keyword-search {
  flex: 0 0 37%;
}

.task-builder-task .dialog-container .facet .filters-options{
  overflow: auto;
  max-height: 200px;
}

.task-builder-task .dialog-container .facet .filters-options ul {
  list-style-type: none;
  padding-left: 0px;
}

.task-builder-task .dialog-container .facet .filters-options input[type="checkbox"]  {
  margin-right: 10px;
}

.task-builder-task .dialog-container .facet .filters-options li {
  list-style-type: none;
}

.task-builder-task .dialog-container .study-keyword-search form{
  margin-top: 18px;
}

.task-builder-task .dialog-container button.filters-toggle svg{
  margin-right: 5px;
}

.task-builder-task .dialog-container .study-keyword-search svg.right {
  right: 9rem;
}

.task-builder-task .dialog-container .study-keyword-search svg.top-1\\/2 {
  top: 4.5rem;
}

/* ResultsTable.css */

/* Reset table styling */
.task-builder-task .dialog-container .table-results table {
  width: 100%;
  border-collapse: collapse;
  margin: 25px 0;
  font-size: 0.9em;
  font-family: sans-serif;
  min-width: 400px;
  background-color: #fff; /* White background for the table */
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
}

.task-builder-task .dialog-container .table-results th,
.task-builder-task .dialog-container .table-results td {
  padding: 12px 15px;
  text-align: center;
  /* border-bottom: 1px solid #ddd; Light grey border for rows */
  border-top: 1px solid #e1e1e1; /* Light grey border */
  border-bottom: 1px solid #e1e1e1; /* Light grey border */
}

.task-builder-task .dialog-container .table-results th {
  /* background-color: #f8f8f8; */
  /* background-color: #f9f9f9;*/
  color: black;
  text-transform: capitalize;
  font-weight: bold;
}

/* .task-builder-task .dialog-container .table-results tr {
  border-bottom: 1px solid #dddddd;
} */

/* .task-builder-task .dialog-container .table-results tr:nth-of-type(odd) {
  /* background-color: #f1f1f1; */
  /* background-color: #f2f2f2; 

} */

/* .task-builder-task .dialog-container .table-results tr:last-of-type {
  border-bottom: 2px solid #009879;
} */

.task-builder-task .dialog-container .table-results tr:hover {
  background-color: #f2f2f2;
}

.task-builder-task .dialog-container .table-results td {
  /* border-right: 1px solid #dddddd; */
  max-width: 200px; /* Adjust the max-width as necessary */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.task-builder-task .dialog-container .table-results td:hover {
  cursor: pointer;
  position: relative;
}

.task-builder-task .dialog-container .table-results .cell-ellipsis {
  display: block; /* or inline-block */
  max-width: 250px; /* or a specific width */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer; /* or default, depending on your need */
}


.task-builder-task .dialog-container .table-results td:last-child {
  border-right: none;
}


.task-builder-task .dialog-container .facet .filter-category {
  /* Your default styles for filter category */
  cursor: pointer;
}

.task-builder-task .dialog-container .facet .filter-category .filters-box-searchable {
  display: none;
  position: absolute;
}

.task-builder-task .dialog-container .facet .filter-category:hover .filters-box-searchable {
  margin-top: -13px;
  display: block;
}


.task-builder-task .dialog-container .facet .filter-category:hover p{
  /* Styles for the highlighted state */
  background-color: #f0f0f0;
}

/* Add styles for applied filters */
.task-builder-task .dialog-container .applied-filters {
  margin-top: 10px;
}

.task-builder-task .dialog-container .applied-filter {
  display: inline-flex;
  align-items: center;
  background-color: #007bff; /* Applied filter background color */
  color: #fff; /* Text color for applied filter */
  padding: 5px 10px;
  margin: 5px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease; /* Add a smooth transition effect */
}

.task-builder-task .dialog-container .applied-filters .applied-filter:hover {
  background-color: #0056b3; /* Hover effect color */
}

.task-builder-task .dialog-container .applied-filters .cross-icon {
  margin-left: 5px;
  color: #fff; /* Cross icon color */
  cursor: pointer;
  transition: color 0.3s ease; /* Add a smooth transition effect */
}

.task-builder-task .dialog-container .applied-filters .cross-icon:hover {
  color: #ff6363; /* Hover effect color for cross icon */
}


/* ResultsTable.css */
.task-builder-task .dialog-container .table-results .action-buttons {
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
}

.task-builder-task .dialog-container .table-results .action-button {
  border: none;
  background: none;
  cursor: pointer;
  padding: 0px;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.task-builder-task .dialog-container .table-results .action-button:hover {
  background-color: #f2f2f2;
}

.task-builder-task .dialog-container .table-results .action-button svg {
  width: 15px;
  height: 15px;
}

.task-builder-task .dialog-container .table-results .table-container {
  margin-top: 20px;
  border-collapse: collapse;
  width: 100%;
}

/* .task-builder-task .dialog-container .table-results .table-container thead {
  background-color: #f0f0f0;
} */

.task-builder-task .dialog-container .table-results .table-container th, .table-container td {
  text-align: center;
  padding: 8px;
}

/* .task-builder-task .dialog-container .table-results .table-container tr:nth-child(even) {
  background-color: #f2f2f2;
} */

@media screen and (max-width: 768px) {
  .task-builder-task .dialog-container .table-results .action-buttons {
      flex-direction: column;
  }
}

.task-builder-task .dialog-container .dialog-close {
  text-align: center;
  margin-top: 1rem;
}


.task-builder-task .metadata-section .label-table-container .table-container {
  overflow-x: auto; /* Enable horizontal scrolling */
  margin: 1rem; /* Add some spacing around the table */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Add a subtle shadow for depth */
}

.task-builder-task .metadata-section .label-table-container .table-container table {
  width: 100%; /* Full width of the container */
  border-collapse: collapse; /* Collapse borders */
  background-color: #fff; /* White background for the table */
}

.task-builder-task .metadata-section .label-table-container .table-container th, td {
  padding: 0.5rem 1rem; /* Padding for table cells */
  text-align: left; /* Align text to the left */
  border-bottom: 1px solid #ddd; /* Light grey border for rows */
}

.task-builder-task .metadata-section .label-table-container .table-container th {
  background-color: #f8f8f8; /* Slightly grey background for headers */
  font-weight: bold; /* Make header text bold */
}

.task-builder-task .metadata-section .label-table-container .table-container tr:hover {
  background-color: #f1f1f1; /* Highlight row on hover */
}

/* Responsive table */
@media screen and (max-width: 600px) {
  .task-builder-task .metadata-section .label-table-container .table-container {
    margin: 0; /* Remove margin in small screens */
  }
  .task-builder-task .metadata-section .label-table-container .table-container th, td {
    padding: 0.5rem; /* Smaller padding for small screens */
  }
}


.task-builder-task .dialog-container .table-results .dropdown{
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
}


/* LogViewer.css */

.live_logs_container {
  padding: 10px;
  width: 95%;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px 1px;
  margin: 2rem 0px;
  border-radius: 0.5rem;
}

.live_logs_container .live_logs_card {
  /* box-shadow: 0px 0px 2px 1px rgba(0,0,0,0.2);
  background-color: #232323; */
  color: black;
  margin-bottom: 10px;
}

.live_logs_container .live_logs_header {
  /* background-color: #323232; */
  margin: 0;
  padding: 10px;
}

.live_logs_container .live_logs_content {
  max-height: 300px;
  overflow: auto;
  background-color: #222222;
  color: white;
  padding: 10px;
  font-size: 0.875rem;
  font-family: monospace;
  border-radius: 1rem;
}

/* For Chrome, Safari, and Opera */
.live_logs_container .live_logs_content::-webkit-scrollbar {
  width: 0.4em;
}

.live_logs_container .live_logs_content::-webkit-scrollbar-thumb {
  background-color: rgba(0,0,0,.1);
  border-radius: 4px;
}


.message-box{
  top: 25px;
  position: fixed !important;
}

.dialog1{
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  width: 65%;
  height: 90vh;
  overflow-y: auto;
  background-color: grey;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 20px;
}

/* ------------------------------------------------------------- */

.my-form-container1 {
  /* max-width: 500px; */
  margin: 0 auto;
  padding: 20px;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  height: 2850px !important;

}

.my-form-container1 .message-box{
  top: 25px;
  position: fixed !important;
}

.my-form-container1 .form-input:not([type=radio]):not([type=checkbox]) {
  width: auto !important;
}

.form-title1 {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

.form1 {
  display: grid;
  gap: 15px;
}

.form-field1 {
  display: flex;
  flex-direction: column;
}

.form-label1 {
  font-size: 16px;
  margin-bottom: 5px;
  color: #444;
}

.form-input1 {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.tab {
  overflow: hidden;
  background-color: #f1f1f1;
}

.tab button {
  background-color: inherit;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  transition: 0.3s;
  font-size: 17px;
  color:#3d5a87;
}

.tab button:hover {
  background-color: #ddd;
}

.tab button.active {
  background-color: #fff;
  color:#333;
}

.tab-content {
  padding: 20px;
  background-color: #f1f1f1;
  border: 1px solid #e3e3e3;
  border-top: none;
}

.tab-content h2 {
  font-size: 24px;
  margin-bottom: 15px;
}

.tab-content p {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 15px;
}

.tab-content .close-button {
  background-color: #007BFF;
  border: none;
  color: white;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin-top: 20px;
  cursor: pointer;
  border-radius: 4px;
}

.tab-content .close-button:hover {
  background-color: dodgerblue;
}

.tab-content{
  width: 100vh;
  /* height: 100vh; */
  border: 2px solid #f00;
  background-color: white;
  margin-top: 20px;
}

.dialog1 {
  /* background-color: #fafafa; */
  border-radius: 4px;
  /* width: 70%;  */
}

.tab-panel {
  padding: 20px;
}

.tab-panel > h2 {
  font-size: 20px;
  font-weight: bold;
  margin-top: 20px;
}

.tab-panel > p {
  font-size: 16px;
  line-height: 1.5;
  margin-top: 10px;
  text-align:justify;
}

.tab-panel > hr {
  margin: 10px 0;
  border: none;
  border-bottom: 1px solid black;
}


/* --------------------------------------------------------------------- */

.dataset-container {
  display: flex;
  justify-content: center;
  padding: 20px;
}

.dataset-dialog-container {
  display: flex;
  max-width: 1200px;
}

.side-panel {
  flex: 1 1;
  padding: 20px;
  border-right: 1px solid #e0e0e0;
}

.dataset-dialog {
  flex: 2 1;
  padding: 20px;
  margin-bottom: 40px;

}

.dataset-tabs {
  display: flex;
  justify-content: flex-start; /* Align items to the start (left) */
  gap: 10px;
  margin-bottom: 40px;
  position: absolute;
  top: 90px; /* Adjust this value according to your design */
  left: 145px; /* Adjusted left value */
  z-index: 999; /* Ensure it's above other content */
}



.dataset-tabs button {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  padding: 10px 20px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.dataset-tabs button.active-tab {
  background-color: #007bff;
  color: #ffffff;
}

.dataset-tab-panel {
  margin-top: 20px;
}

.dataset-tab-panel h2 {
  font-size: 18px;
  margin-bottom: 10px;
}

.dataset-tab-panel p {
  font-size: 16px;
  line-height: 1.5;
}

.dataset-tab-panel hr {
  margin: 10px 0;
  border: none;
  border-top: 1px solid #e0e0e0;
}

.dataset-tab-content {
  background-color: #fefefe;

  border: 2px solid #ccc;
  border-radius: 5px;
  padding: 20px;
  margin-top: 60px; /* Adjusted margin-top value to move it below the tabs */
  margin-bottom: 30px;}

.side-panel {
  background-color: #fefefe;
  border: 2px solid #ccc;
  border-radius: 5px;
  padding: 20px;
  margin-top: 78px !important;

}

.side-panel h2 {
  font-size: 18px;
  margin-top: 0;
}

.side-panel p {
  margin: 5px 0;
}

.side-panel hr {
  border: none;
  border-top: 1px solid #ccc;
  margin: 10px 0;
}

.dataset-container {
  background-color: #ebe8e8;
}

#plot-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 10vh; /* Makes the container take the full height of the viewport */
  font-size: 1.5rem; /* Increases the font size */
}`, "",{"version":3,"sources":["webpack://./src/components/publishDatasets/publishDatasets.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,4CAA4C;IAC5C,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;;GAEG;;AAEH;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,cAAc,EAAE,8BAA8B;EAChD;;;;EAIA,gCAAgC;;AAElC;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;AAEF;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,SAAO;AACX;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;;AAIA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;AACf;;;AAGA,0CAA0C;AAC1C;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,aAAa;AACf;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;EAC5B,WAAW;EACX,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;IACjB,iBAAiB;IACjB,mBAAmB;;IAEnB,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;IAC5B,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,YAAY;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,qBAAqB;;AAErB,wBAAwB;AACxB;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB,EAAE,mCAAmC;EAC3D,wCAAwC;AAC1C;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,8DAA8D;EAC9D,6BAA6B,EAAE,sBAAsB;EACrD,gCAAgC,EAAE,sBAAsB;AAC1D;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;iCACiC;EAC/B;;GAEC;;AAEH;;GAEG;;AAEH;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,gBAAgB,EAAE,sCAAsC;EACxD,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,oBAAoB;EACpC,gBAAgB,EAAE,wBAAwB;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe,EAAE,uCAAuC;AAC1D;;;AAGA;EACE,kBAAkB;AACpB;;;AAGA;EACE,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;;AAGA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB,EAAE,oCAAoC;EAC/D,WAAW,EAAE,kCAAkC;EAC/C,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,sCAAsC,EAAE,mCAAmC;AAC7E;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA;EACE,gBAAgB;EAChB,WAAW,EAAE,qBAAqB;EAClC,eAAe;EACf,2BAA2B,EAAE,mCAAmC;AAClE;;AAEA;EACE,cAAc,EAAE,sCAAsC;AACxD;;;AAGA,qBAAqB;AACrB;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;;GAEG;;AAEH;EACE;MACI,sBAAsB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB,EAAE,gCAAgC;EAClD,YAAY,EAAE,sCAAsC;EACpD,uCAAuC,EAAE,kCAAkC;AAC7E;;AAEA;EACE,WAAW,EAAE,gCAAgC;EAC7C,yBAAyB,EAAE,qBAAqB;EAChD,sBAAsB,EAAE,mCAAmC;AAC7D;;AAEA;EACE,oBAAoB,EAAE,4BAA4B;EAClD,gBAAgB,EAAE,2BAA2B;EAC7C,6BAA6B,EAAE,+BAA+B;AAChE;;AAEA;EACE,yBAAyB,EAAE,yCAAyC;EACpE,iBAAiB,EAAE,0BAA0B;AAC/C;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA,qBAAqB;AACrB;EACE;IACE,SAAS,EAAE,mCAAmC;EAChD;EACA;IACE,eAAe,EAAE,sCAAsC;EACzD;AACF;;;AAGA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,WAAW;AACb;;;AAGA,kBAAkB;;AAElB;EACE,aAAa;EACb,UAAU;EACV,8CAA8C;EAC9C,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE;8BAC4B;EAC5B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,SAAS;EACT,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;;AAGA;EACE,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;AACf;;AAEA,kEAAkE;;AAElE;EACE,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;EACvC,yBAAyB;;AAE3B;;AAEA;EACE,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,8BAA8B;AAChC;;;AAGA,0EAA0E;;AAE1E;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;;AAErB;;AAEA;EACE,aAAa;EACb,2BAA2B,EAAE,oCAAoC;EACjE,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,SAAS,EAAE,+CAA+C;EAC1D,WAAW,EAAE,wBAAwB;EACrC,YAAY,EAAE,oCAAoC;AACpD;;;;AAIA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;;EAEzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,gBAAgB,EAAE,wDAAwD;EAC1E,mBAAmB,CAAC;;AAEtB;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,2BAA2B;;AAE7B;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY,EAAE,6DAA6D;EAC3E,iBAAiB,EAAE,4BAA4B;AACjD","sourcesContent":[".benchmarks-left-nav ul {\n    margin-top: 20%;\n}\n\n.benchmarks-left-nav li {\n    padding: 11px 0px;\n    padding-left: 40px;\n    word-break: break-word;\n    cursor: not-allowed;\n    color: #ccc;\n}\n\n.benchmarks-left-nav a {\n    cursor: not-allowed;\n}\n\n.benchmarks-left-nav li.active, .benchmarks-left-nav li.active a {\n    cursor: pointer; \n    background-color: hsl(0, 0%, 90%) !important;\n    color: #000;\n}\n\n.benchmarks-left-nav li.completed, .benchmarks-left-nav li.completed a {\n    cursor: pointer; \n    color: #000;\n}\n\n.upload-task .uppy-comp {\n    margin: 2% 15%;\n}\n\n.upload-task, .validation-task {\n    padding: 3%;\n}\n\n.uppy-uploader-component {\n    margin-top: 3%;\n}\n\n/* .uppy-uploader-component span{\n    margin-left: 2rem;\n} */\n\n.upload-task .uppy-Dashboard {\n    height: 23rem;\n}\n\n.next-upon-success button{\n    float: right;\n    cursor: pointer;\n}\n.next-upon-success button{\n    margin-top: 5px;\n}\n\n.upload-task .uploaded-files {\n    margin-left: 2rem;\n    margin-top: 20px;\n}\n\n.upload-task .file-list-heading {\n    font-size: 18px;\n    font-weight: bold;\n    color: #333;\n    margin-bottom: 10px;\n  }\n  \n  .upload-task .file-list {\n    list-style: none;\n    padding: 0;\n  }\n  \n  .upload-task .file-list-item {\n    font-size: 16px;\n    margin-bottom: 5px;\n    text-decoration: none;\n    transition: color 0.3s;\n  }\n  \n  .upload-task .file-list-item:hover {\n    color: #007bff; /* Change the color on hover */\n  }\n  \n\n\n  /* ValidationTaskComponent.css */\n\n.validation-task .container {\n    padding: 20px;\n    border-radius: 10px;\n    background-color: #f5f5f5;\n  }\n  \n  .validation-task .header {\n    font-size: 24px;\n    color: #333;\n    margin-bottom: 20px;\n  }\n  \n  .validation-task .spinner-container, .spinner-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100px;\n  }\n  \n  .navigation-buttons .button, .next-upon-success button {\n    margin: 10px;\n    padding: 10px 20px;\n    background-color: #007BFF;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n  \n  .navigation-buttons .button:hover {\n    background-color: #0056b3;\n  }\n\n.navigation-buttons {\n    display: flex;\n    margin-top: 2rem;\n}\n\n.navigation-buttons .previous, .navigation-buttons .next-upon-success {\n    flex: 1;\n}\n\n\n.task-builder-task .task-section, .task-builder-task .task-id-section, .task-builder-task .metadata-section, .task-builder-task .metadata-item, .task-builder-task .split-parameters {\n  margin-bottom: 15px;\n}\n\n.task-builder-task h3 {\n  font-size: 18px;\n  margin-bottom: 10px;\n}\n\n.task-builder-task label {\n  display: block;\n  margin-bottom: 2rem;\n  font-weight: 500;\n}\n\n.task-builder-task label p{\n  margin-bottom: 5px;\n}\n\n.task-builder-task input[type=\"range\"] {\n  width: 80%;\n}\n\n.task-builder-task button {\n  margin: 10px;\n  padding: 10px 20px;\n  background-color: #007BFF;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.task-builder-task button:hover {\n  background-color: #0056b3;\n}\n\n\n\n.review-task {\n  width: 95%;\n  margin: auto;\n  padding: 20px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.section {\n  margin-bottom: 20px;\n}\n\n.section-heading {\n  background-color: rgb(248, 249, 250)  ;\n  color: black;\n  padding: 10px;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  text-align: left;\n  outline: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 2rem;\n}\n\n.section-heading i {\n  font-size: 16px;\n  margin-right: 8px;\n}\n\n.section-content {\n  display: none;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  margin-top: 10px;\n}\n\n\n/* FlowControl.css */\n.flow-messaging {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-family: Arial, sans-serif;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin: 5rem 25rem;\n  padding: 4rem 2rem;\n}\n\n.flow-messaging h3 {\n  text-align: center;\n  margin-bottom: 20px;\n  padding: 0 7rem;\n}\n\n.flow-messaging button {\n  margin: 10px;\n  padding: 10px 20px;\n  font-size: 16px;\n  border: none;\n  border-radius: 5px;\n  background-color: #007BFF;\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.flow-messaging button:hover {\n  background-color: #0056b3;\n}\n\n.uppy-uploader-component .info-icon {\n  top: 0px !important;\n  float: left;\n}\n\n.upload-task .files-selected button.cross-button {\n  cursor: pointer;\n}\n\n#files-selected ul {\n  padding-left: 0px;\n}\n\n.task-builder-task .dialog-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  z-index: 999;\n}\n\n.task-builder-task .dialog {\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n  width: 80%;\n  max-height: 90vh;\n  overflow-y: auto;\n  background-color: #ffffff;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  padding: 20px;\n}\n\n\n/* Additional styles for FilterComponent */\n.task-builder-task .dialog-container .filter {\n  flex: 1;\n}\n\n.task-builder-task .dialog-container .pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n}\n\n.task-builder-task .dialog-container .pagination button {\n  padding: 5px 10px;\n  background-color: #f0f0f0;\n  border: 1px solid #ddd;\n  cursor: pointer;\n}\n\n.task-builder-task .dialog-container .pagination button:disabled {\n  background-color: #e0e0e0;\n  cursor: default;\n}\n\n.task-builder-task .dialog-container .pagination span {\n  margin: 0 10px;\n}\n\n.task-builder-task .dialog-container .filters-and-search-container {\n  display: flex;\n}\n\n.task-builder-task .dialog-container span.search-title {\n  font-weight: 700;\n  color: #666;\n  display: block;\n  margin: 3px 0;\n}\n\n.task-builder-task .dialog-container .facet {\n    white-space: nowrap;\n    display: inline-block;\n    margin-right: 8px;\n    box-sizing: border-box;\n    vertical-align: top;\n    cursor: pointer;\n}\n\n.task-builder-task .dialog-container .table-results {\n  overflow-y: auto;\n}\n\n.task-builder-task .dialog-container .table-results table{\n\n  width: 100%;\n}\n\n.task-builder-task .dialog-container .facet p {\n  background-color: #fff;\n  padding: 8px 16px;\n  border-radius: 15px;\n  border: 0.64px solid #4d72aa;\n  width: 100%;\n  box-sizing: border-box;\n  display: inline-block;\n}\n\n.task-builder-task .dialog-container .facet .filters-box-searchable {\n  width: 375px;\n  border: 1px solid #aaa;\n  background: #fff;\n  position: absolute;\n  z-index: 9000;\n  border-radius: 5px;\n  padding: 1rem;\n  margin-top: 2px;\n}\n\n.task-builder-task .dialog-container .facet .filters-box-searchable {\n  display: flex;\n  flex-direction: column;\n}\n\n\n.task-builder-task .dialog-container .facet .filters-box-footer {\n  height: 40px;\n}\n\n.task-builder-task .dialog-container button.filters-toggle{\n  margin-top: 18px;\n  white-space: nowrap;\n    margin-right: 8px;\n    vertical-align: top;\n\n    background-color: #fff;\n    color: black;\n    border-radius: 15px;\n    border: 0.64px solid #4d72aa;\n    box-sizing: border-box;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    padding: 0px 16px;\n    height: 40px;\n}\n\n.task-builder-task .dialog-container .filters-toggle-div {\n  display: inline-block;\n}\n\n.task-builder-task .dialog-container .metadata-search-wrap {\n  flex: 0 0 60%;\n}\n\n.task-builder-task .dialog-container .study-keyword-search {\n  flex: 0 0 37%;\n}\n\n.task-builder-task .dialog-container .facet .filters-options{\n  overflow: auto;\n  max-height: 200px;\n}\n\n.task-builder-task .dialog-container .facet .filters-options ul {\n  list-style-type: none;\n  padding-left: 0px;\n}\n\n.task-builder-task .dialog-container .facet .filters-options input[type=\"checkbox\"]  {\n  margin-right: 10px;\n}\n\n.task-builder-task .dialog-container .facet .filters-options li {\n  list-style-type: none;\n}\n\n.task-builder-task .dialog-container .study-keyword-search form{\n  margin-top: 18px;\n}\n\n.task-builder-task .dialog-container button.filters-toggle svg{\n  margin-right: 5px;\n}\n\n.task-builder-task .dialog-container .study-keyword-search svg.right {\n  right: 9rem;\n}\n\n.task-builder-task .dialog-container .study-keyword-search svg.top-1\\/2 {\n  top: 4.5rem;\n}\n\n/* ResultsTable.css */\n\n/* Reset table styling */\n.task-builder-task .dialog-container .table-results table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 25px 0;\n  font-size: 0.9em;\n  font-family: sans-serif;\n  min-width: 400px;\n  background-color: #fff; /* White background for the table */\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);\n}\n\n.task-builder-task .dialog-container .table-results th,\n.task-builder-task .dialog-container .table-results td {\n  padding: 12px 15px;\n  text-align: center;\n  /* border-bottom: 1px solid #ddd; Light grey border for rows */\n  border-top: 1px solid #e1e1e1; /* Light grey border */\n  border-bottom: 1px solid #e1e1e1; /* Light grey border */\n}\n\n.task-builder-task .dialog-container .table-results th {\n  /* background-color: #f8f8f8; */\n  /* background-color: #f9f9f9;*/\n  color: black;\n  text-transform: capitalize;\n  font-weight: bold;\n}\n\n/* .task-builder-task .dialog-container .table-results tr {\n  border-bottom: 1px solid #dddddd;\n} */\n\n/* .task-builder-task .dialog-container .table-results tr:nth-of-type(odd) {\n  /* background-color: #f1f1f1; */\n  /* background-color: #f2f2f2; \n\n} */\n\n/* .task-builder-task .dialog-container .table-results tr:last-of-type {\n  border-bottom: 2px solid #009879;\n} */\n\n.task-builder-task .dialog-container .table-results tr:hover {\n  background-color: #f2f2f2;\n}\n\n.task-builder-task .dialog-container .table-results td {\n  /* border-right: 1px solid #dddddd; */\n  max-width: 200px; /* Adjust the max-width as necessary */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.task-builder-task .dialog-container .table-results td:hover {\n  cursor: pointer;\n  position: relative;\n}\n\n.task-builder-task .dialog-container .table-results .cell-ellipsis {\n  display: block; /* or inline-block */\n  max-width: 250px; /* or a specific width */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer; /* or default, depending on your need */\n}\n\n\n.task-builder-task .dialog-container .table-results td:last-child {\n  border-right: none;\n}\n\n\n.task-builder-task .dialog-container .facet .filter-category {\n  /* Your default styles for filter category */\n  cursor: pointer;\n}\n\n.task-builder-task .dialog-container .facet .filter-category .filters-box-searchable {\n  display: none;\n  position: absolute;\n}\n\n.task-builder-task .dialog-container .facet .filter-category:hover .filters-box-searchable {\n  margin-top: -13px;\n  display: block;\n}\n\n\n.task-builder-task .dialog-container .facet .filter-category:hover p{\n  /* Styles for the highlighted state */\n  background-color: #f0f0f0;\n}\n\n/* Add styles for applied filters */\n.task-builder-task .dialog-container .applied-filters {\n  margin-top: 10px;\n}\n\n.task-builder-task .dialog-container .applied-filter {\n  display: inline-flex;\n  align-items: center;\n  background-color: #007bff; /* Applied filter background color */\n  color: #fff; /* Text color for applied filter */\n  padding: 5px 10px;\n  margin: 5px;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease; /* Add a smooth transition effect */\n}\n\n.task-builder-task .dialog-container .applied-filters .applied-filter:hover {\n  background-color: #0056b3; /* Hover effect color */\n}\n\n.task-builder-task .dialog-container .applied-filters .cross-icon {\n  margin-left: 5px;\n  color: #fff; /* Cross icon color */\n  cursor: pointer;\n  transition: color 0.3s ease; /* Add a smooth transition effect */\n}\n\n.task-builder-task .dialog-container .applied-filters .cross-icon:hover {\n  color: #ff6363; /* Hover effect color for cross icon */\n}\n\n\n/* ResultsTable.css */\n.task-builder-task .dialog-container .table-results .action-buttons {\n  display: flex;\n  gap: 4px;\n  justify-content: center;\n  align-items: center;\n}\n\n.task-builder-task .dialog-container .table-results .action-button {\n  border: none;\n  background: none;\n  cursor: pointer;\n  padding: 0px;\n  border-radius: 5px;\n  transition: background-color 0.3s;\n}\n\n.task-builder-task .dialog-container .table-results .action-button:hover {\n  background-color: #f2f2f2;\n}\n\n.task-builder-task .dialog-container .table-results .action-button svg {\n  width: 15px;\n  height: 15px;\n}\n\n.task-builder-task .dialog-container .table-results .table-container {\n  margin-top: 20px;\n  border-collapse: collapse;\n  width: 100%;\n}\n\n/* .task-builder-task .dialog-container .table-results .table-container thead {\n  background-color: #f0f0f0;\n} */\n\n.task-builder-task .dialog-container .table-results .table-container th, .table-container td {\n  text-align: center;\n  padding: 8px;\n}\n\n/* .task-builder-task .dialog-container .table-results .table-container tr:nth-child(even) {\n  background-color: #f2f2f2;\n} */\n\n@media screen and (max-width: 768px) {\n  .task-builder-task .dialog-container .table-results .action-buttons {\n      flex-direction: column;\n  }\n}\n\n.task-builder-task .dialog-container .dialog-close {\n  text-align: center;\n  margin-top: 1rem;\n}\n\n\n.task-builder-task .metadata-section .label-table-container .table-container {\n  overflow-x: auto; /* Enable horizontal scrolling */\n  margin: 1rem; /* Add some spacing around the table */\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Add a subtle shadow for depth */\n}\n\n.task-builder-task .metadata-section .label-table-container .table-container table {\n  width: 100%; /* Full width of the container */\n  border-collapse: collapse; /* Collapse borders */\n  background-color: #fff; /* White background for the table */\n}\n\n.task-builder-task .metadata-section .label-table-container .table-container th, td {\n  padding: 0.5rem 1rem; /* Padding for table cells */\n  text-align: left; /* Align text to the left */\n  border-bottom: 1px solid #ddd; /* Light grey border for rows */\n}\n\n.task-builder-task .metadata-section .label-table-container .table-container th {\n  background-color: #f8f8f8; /* Slightly grey background for headers */\n  font-weight: bold; /* Make header text bold */\n}\n\n.task-builder-task .metadata-section .label-table-container .table-container tr:hover {\n  background-color: #f1f1f1; /* Highlight row on hover */\n}\n\n/* Responsive table */\n@media screen and (max-width: 600px) {\n  .task-builder-task .metadata-section .label-table-container .table-container {\n    margin: 0; /* Remove margin in small screens */\n  }\n  .task-builder-task .metadata-section .label-table-container .table-container th, td {\n    padding: 0.5rem; /* Smaller padding for small screens */\n  }\n}\n\n\n.task-builder-task .dialog-container .table-results .dropdown{\n  display: inline-flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n\n/* LogViewer.css */\n\n.live_logs_container {\n  padding: 10px;\n  width: 95%;\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px 1px;\n  margin: 2rem 0px;\n  border-radius: 0.5rem;\n}\n\n.live_logs_container .live_logs_card {\n  /* box-shadow: 0px 0px 2px 1px rgba(0,0,0,0.2);\n  background-color: #232323; */\n  color: black;\n  margin-bottom: 10px;\n}\n\n.live_logs_container .live_logs_header {\n  /* background-color: #323232; */\n  margin: 0;\n  padding: 10px;\n}\n\n.live_logs_container .live_logs_content {\n  max-height: 300px;\n  overflow: auto;\n  background-color: #222222;\n  color: white;\n  padding: 10px;\n  font-size: 0.875rem;\n  font-family: monospace;\n  border-radius: 1rem;\n}\n\n/* For Chrome, Safari, and Opera */\n.live_logs_container .live_logs_content::-webkit-scrollbar {\n  width: 0.4em;\n}\n\n.live_logs_container .live_logs_content::-webkit-scrollbar-thumb {\n  background-color: rgba(0,0,0,.1);\n  border-radius: 4px;\n}\n\n\n.message-box{\n  top: 25px;\n  position: fixed !important;\n}\n\n.dialog1{\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n  width: 65%;\n  height: 90vh;\n  overflow-y: auto;\n  background-color: grey;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  padding: 20px;\n}\n\n/* ------------------------------------------------------------- */\n\n.my-form-container1 {\n  /* max-width: 500px; */\n  margin: 0 auto;\n  padding: 20px;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  height: 2850px !important;\n\n}\n\n.my-form-container1 .message-box{\n  top: 25px;\n  position: fixed !important;\n}\n\n.my-form-container1 .form-input:not([type=radio]):not([type=checkbox]) {\n  width: auto !important;\n}\n\n.form-title1 {\n  font-size: 24px;\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.form1 {\n  display: grid;\n  gap: 15px;\n}\n\n.form-field1 {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-label1 {\n  font-size: 16px;\n  margin-bottom: 5px;\n  color: #444;\n}\n\n.form-input1 {\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.tab {\n  overflow: hidden;\n  background-color: #f1f1f1;\n}\n\n.tab button {\n  background-color: inherit;\n  float: left;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  padding: 14px 16px;\n  transition: 0.3s;\n  font-size: 17px;\n  color:#3d5a87;\n}\n\n.tab button:hover {\n  background-color: #ddd;\n}\n\n.tab button.active {\n  background-color: #fff;\n  color:#333;\n}\n\n.tab-content {\n  padding: 20px;\n  background-color: #f1f1f1;\n  border: 1px solid #e3e3e3;\n  border-top: none;\n}\n\n.tab-content h2 {\n  font-size: 24px;\n  margin-bottom: 15px;\n}\n\n.tab-content p {\n  font-size: 16px;\n  line-height: 1.6;\n  margin-bottom: 15px;\n}\n\n.tab-content .close-button {\n  background-color: #007BFF;\n  border: none;\n  color: white;\n  padding: 10px 20px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  margin-top: 20px;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.tab-content .close-button:hover {\n  background-color: dodgerblue;\n}\n\n.tab-content{\n  width: 100vh;\n  /* height: 100vh; */\n  border: 2px solid #f00;\n  background-color: white;\n  margin-top: 20px;\n}\n\n.dialog1 {\n  /* background-color: #fafafa; */\n  border-radius: 4px;\n  /* width: 70%;  */\n}\n\n.tab-panel {\n  padding: 20px;\n}\n\n.tab-panel > h2 {\n  font-size: 20px;\n  font-weight: bold;\n  margin-top: 20px;\n}\n\n.tab-panel > p {\n  font-size: 16px;\n  line-height: 1.5;\n  margin-top: 10px;\n  text-align:justify;\n}\n\n.tab-panel > hr {\n  margin: 10px 0;\n  border: none;\n  border-bottom: 1px solid black;\n}\n\n\n/* --------------------------------------------------------------------- */\n\n.dataset-container {\n  display: flex;\n  justify-content: center;\n  padding: 20px;\n}\n\n.dataset-dialog-container {\n  display: flex;\n  max-width: 1200px;\n}\n\n.side-panel {\n  flex: 1;\n  padding: 20px;\n  border-right: 1px solid #e0e0e0;\n}\n\n.dataset-dialog {\n  flex: 2;\n  padding: 20px;\n  margin-bottom: 40px;\n\n}\n\n.dataset-tabs {\n  display: flex;\n  justify-content: flex-start; /* Align items to the start (left) */\n  gap: 10px;\n  margin-bottom: 40px;\n  position: absolute;\n  top: 90px; /* Adjust this value according to your design */\n  left: 145px; /* Adjusted left value */\n  z-index: 999; /* Ensure it's above other content */\n}\n\n\n\n.dataset-tabs button {\n  background-color: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 5px;\n  padding: 10px 20px;\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.dataset-tabs button.active-tab {\n  background-color: #007bff;\n  color: #ffffff;\n}\n\n.dataset-tab-panel {\n  margin-top: 20px;\n}\n\n.dataset-tab-panel h2 {\n  font-size: 18px;\n  margin-bottom: 10px;\n}\n\n.dataset-tab-panel p {\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n.dataset-tab-panel hr {\n  margin: 10px 0;\n  border: none;\n  border-top: 1px solid #e0e0e0;\n}\n\n.dataset-tab-content {\n  background-color: #fefefe;\n\n  border: 2px solid #ccc;\n  border-radius: 5px;\n  padding: 20px;\n  margin-top: 60px; /* Adjusted margin-top value to move it below the tabs */\n  margin-bottom: 30px;}\n\n.side-panel {\n  background-color: #fefefe;\n  border: 2px solid #ccc;\n  border-radius: 5px;\n  padding: 20px;\n  margin-top: 78px !important;\n\n}\n\n.side-panel h2 {\n  font-size: 18px;\n  margin-top: 0;\n}\n\n.side-panel p {\n  margin: 5px 0;\n}\n\n.side-panel hr {\n  border: none;\n  border-top: 1px solid #ccc;\n  margin: 10px 0;\n}\n\n.dataset-container {\n  background-color: #ebe8e8;\n}\n\n#plot-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 10vh; /* Makes the container take the full height of the viewport */\n  font-size: 1.5rem; /* Increases the font size */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
